/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit'
import { IContactGroupParticipant } from '@dataTypes/contact.type'
import {
  createContactGroupParticipant,
  bulkCreateContactGroupParticipant,
  deleteMultipleContactGroupParticipant,
} from '@services/api/contact-group-participant.api'
import { fetchAllContactGroups } from './contact-group.action'

export const addContactGroupParticipant = createAsyncThunk<
  void,
  IContactGroupParticipant,
  {
    rejectValue: string
  }
>(
  'api/contact-participant/add',
  async (participantData, { dispatch, rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}')
      const response = await createContactGroupParticipant({
        ...participantData,
        created_by: user.user_id,
        updated_by: user.user_id,
      })

      if (response.statusCode !== 201) {
        return rejectWithValue(
          response.message || 'Failed to add contact group participant',
        )
      }

      dispatch(fetchAllContactGroups())
    } catch (error: any) {
      return rejectWithValue(
        error.message || 'Failed to create contact group participant',
      )
    }
  },
)

export const bulkAddContactGroupParticipant = createAsyncThunk<
  IContactGroupParticipant[],
  IContactGroupParticipant[],
  {
    rejectValue: string
  }
>(
  'api/contact-participant/bulk-add',
  async (participantData, { dispatch, rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}')
      const response = await bulkCreateContactGroupParticipant(
        participantData.map((p) => ({
          ...p,
          created_by: user.user_id,
          updated_by: user.user_id,
        })),
      )

      if (response.statusCode !== 201) {
        return rejectWithValue(
          response.message || 'Failed to add contact group participant',
        )
      }

      dispatch(fetchAllContactGroups())
      return response.data.contact_group_participants ?? participantData
    } catch (error: any) {
      return rejectWithValue(
        error.message || 'Failed to create contact group participant',
      )
    }
  },
)

export const bulkDeleteContactGroupParticipant = createAsyncThunk<
  void,
  string[],
  {
    rejectValue: string
  }
>(
  'api/contact-participant/bulk-delete',
  async (participantIds, { dispatch, rejectWithValue }) => {
    try {
      const response =
        await deleteMultipleContactGroupParticipant(participantIds)

      if (response.statusCode !== 200) {
        return rejectWithValue(
          response.message || 'Failed to delete contact group participant',
        )
      }

      dispatch(fetchAllContactGroups())
    } catch (error: any) {
      return rejectWithValue(
        error.message || 'Failed to delete contact group participant',
      )
    }
  },
)
